import { render, staticRenderFns } from "./VInventoryItemMoveModal.vue?vue&type=template&id=d742e836"
import script from "./VInventoryItemMoveModal.vue?vue&type=script&lang=js"
export * from "./VInventoryItemMoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports